export function safeReturnPath(value: string | null | undefined): string | null {
  if (
    !value ||
    value === "/" ||
    value === "/login" ||
    value.startsWith("//") ||
    value.startsWith("/auth/") ||
    !value.startsWith("/")
  ) {
    return null;
  }
  return value;
}
